var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1673 39.9996C20.1858 39.9996 22.7109 37.8478 23.2907 34.9996H11.044C11.6241 37.8478 14.1491 39.9996 17.1673 39.9996ZM28.8541 19.998C28.8473 19.998 28.8406 19.9996 28.8339 19.9996C22.4023 19.9996 17.1673 14.7661 17.1673 8.33301C17.1673 6.56449 17.5741 4.89277 18.2824 3.38949C17.9156 3.35465 17.5439 3.33301 17.1673 3.33301C10.7241 3.33301 5.50078 8.55606 5.50078 14.9996V19.6462C5.50078 22.9445 4.05578 26.0579 1.52062 28.2011C0.675621 28.923 0.300621 30.0728 0.603902 31.1946C0.957261 32.4996 2.24726 33.333 3.60078 33.333H30.7256C32.1455 33.333 33.4841 32.4129 33.7722 31.0213C33.9956 29.9446 33.6123 28.8695 32.7773 28.1679C30.3538 26.1364 28.9523 23.1511 28.8541 19.998Z",
    fill: "url(#paint0_linear_11686_2357)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1675 8.33344C37.1675 12.9358 33.4367 16.6666 28.8341 16.6666C24.2317 16.6666 20.5009 12.9358 20.5009 8.33344C20.5009 3.73109 24.2317 0 28.8341 0C33.4367 0 37.1675 3.73109 37.1675 8.33344Z",
    fill: "url(#paint1_linear_11686_2357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_2357",
    x1: 4.68775,
    y1: 4.05183,
    x2: 37.4075,
    y2: 27.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11686_2357",
    x1: 22.5948,
    y1: 0.326735,
    x2: 37.881,
    y2: 12.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.07234a7a52cd043f50415632f0f460cf.svg";
export { ForwardRef as ReactComponent };